import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import breakpoints from '../../../breakpoints';
// eslint-disable-next-line import/no-cycle
import BlockBuilder from '../../BlockBuilder';

const Container = styled.div`
  margin-block: 2rem;
`;

const TwoColumnLayoutWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${({ columnSpacing }) =>
    columnSpacing ? `${columnSpacing}px` : '0px'};

  .dynamic-dealer-pricing {
    margin-top: 0;
    margin-bottom: 0;
  }

  @media (min-width: ${breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Column = styled.div`
  padding: 20px;
  border: ${({ border, theme }) =>
    border ? `1px solid ${theme.colors.border}` : `0`};
  align-self: ${({ verticalAlign }) => {
    if (verticalAlign === 'Top') return 'start';
    if (verticalAlign === 'Center') return 'center';
    return 'end';
  }};
`;

function BlockBuilderTwoColumnLayout({ value, getInternalLink }) {
  const {
    heading,
    primaryColumn,
    secondaryColumn,
    primaryColumnVerticalAlignment,
    secondaryColumnVerticalAlignment,
    primaryColumnBorder,
    secondaryColumnBorder,
    columnSpacing,
  } = value;

  return (
    <Container>
      {heading && <h2>{heading}</h2>}
      <TwoColumnLayoutWrapper columnSpacing={columnSpacing}>
        {primaryColumn?.blocks && primaryColumn?.blocks?.length > 0 && (
          <Column
            border={primaryColumnBorder}
            verticalAlign={primaryColumnVerticalAlignment}
          >
            <BlockBuilder
              blocks={primaryColumn.blocks}
              getInternalLink={getInternalLink}
            />
          </Column>
        )}

        {secondaryColumn?.blocks && secondaryColumn?.blocks?.length > 0 && (
          <Column
            border={secondaryColumnBorder}
            verticalAlign={secondaryColumnVerticalAlignment}
          >
            <BlockBuilder
              blocks={secondaryColumn.blocks}
              getInternalLink={getInternalLink}
            />
          </Column>
        )}
      </TwoColumnLayoutWrapper>
    </Container>
  );
}

BlockBuilderTwoColumnLayout.propTypes = {
  value: PropTypes.shape({
    heading: PropTypes.string,
    primaryColumn: PropTypes.shape({
      blocks: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    secondaryColumn: PropTypes.shape({
      blocks: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    primaryColumnVerticalAlignment: PropTypes.string,
    secondaryColumnVerticalAlignment: PropTypes.string,
    primaryColumnBorder: PropTypes.bool,
    secondaryColumnBorder: PropTypes.bool,
    columnSpacing: PropTypes.number,
  }).isRequired,
  getInternalLink: PropTypes.func.isRequired,
};

export default BlockBuilderTwoColumnLayout;
